/* eslint-disable react/no-unknown-property */
/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
import React, { useCallback, useEffect, useState } from 'react';
import UserInfo from '../components/UserInfo';
import {
  CenteredContainer,
  Heading,
  VariableText,
} from '../components/Typography';
import DataTable from '../components/Table';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { SERVICES } from '../components/Services';
import DownloadIcon from '@mui/icons-material/Download';
import { get } from '../components/ApiHandler/apihandler';
import { toast } from 'react-toastify';
import Loader from '../components/Loader/Loader';
import NoData from '../components/NoData';
import Form10BETable from '../components/Table/Form10BETable';
import { Box, TextField } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import AutoCompleteDropdown from '../components/AutoCompleteDropdown/AutoCompleteDropdown';
import { Helmet } from 'react-helmet';

const HOST1 = process.env.REACT_APP_SECONDARY_API_BASE_URL;

const Button = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  border: none;
  background: rgba(0, 0, 0, 0);
  color: #53a8a0;
  cursor: pointer;
  text-align: center;
`;

const Text = styled(VariableText)`
  @media (max-width: 767px) {
    width: 100%;
  }
`;

const UserBoxx = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  width: 80%;
  margin: auto;
  background: #e3f0ff;
  @media (max-width: 767px) {
    width: 100%;
    flex-direction: column;
  }
`;

const ContRicipt = styled.div`
  display: flex;
  // align-items: flex-start;
  justify-content: flex-start;
  margin: auto;
  background: #fff;
  flex-direction: column;
  padding-left: 20px;
  @media (max-width: 1024px) {
    width: 100%;
    padding-left: 0;
    padding: 15px;
    box-sizing: border-box;
  }
`;
const pageSize = 5;
const ContributionForm10BEListing = () => {
  const memberId = useSelector((state) => state.member.memberId);
  const [form10BEData, setForm10BEData] = useState({});
  const [tableData, setTableData] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const previousYear = new Date().getFullYear() - 1;
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedDateForApi, setSelectedDateForApi] = useState(null);

  const getLast10FinancialYears = () => {
    const currentYear = new Date().getFullYear();
    const financialYears = [];
    for (let i = 0; i < 2; i++) {
      const year = currentYear - i;
      financialYears.push({
        value: `${year - 1}`,
        label: `FY-${year - 1}-${year}`,
      });
    }
    return financialYears;
  };
  const financialFields = getLast10FinancialYears();
  const [selectedFinancialField, setSelectedFinancialField] = useState(
    financialFields[0]?.value
  );
  const handleErrorToast = () => {
    toast.error('No data found', {
      position: 'top-center',
      autoClose: 3000,
      hideProgressBar: true,
      closeOnClick: true,
      draggable: true,
      closeButton: false,
    });
  };

  const fetchForm10BEData = async () => {
    const url = `${SERVICES.GET_MEMBER_DETAILS}/${memberId}/form10?contributionYear=${previousYear}`;
    const response = await get(url);
    try {
      setIsLoading(true);
      if (response.ok) {
        const data = await response.json();
        setForm10BEData(data.data);
      } else {
        toast.error('Something Went Wrong', {
          position: 'top-center',
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          draggable: true,
          closeButton: false,
        });
      }
    } catch (error) {
      console.log(error);
      setIsLoading(false);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchForm10BEDataWhileOnchange = async (date) => {
    const url = `${SERVICES.GET_MEMBER_DETAILS}/${memberId}/form10?contributionYear=${date}`;
    const response = await get(url);
    try {
      setIsLoading(true);
      if (response.ok) {
        const data = await response.json();
        setForm10BEData(data.data);
        if (data?.data?.content.length === 0) {
          handleErrorToast();
        }
      } else {
        toast.error('Something Went Wrong', {
          position: 'top-center',
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          draggable: true,
          closeButton: false,
        });
      }
    } catch (error) {
      console.log(error);
      setIsLoading(false);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchForm10BEData();
  }, []);

  const handlePageChange = async (selectedPage) => {
    setCurrentPage(selectedPage);
    try {
      setIsLoading(true);
      const url = `${SERVICES.GET_MEMBER_DETAILS}/${memberId}/form10?page=${selectedPage}&size=${pageSize}&contributionYear=${selectedDateForApi}`;
      const response = await get(url);

      if (response && response.ok) {
        const data = await response.json();
        setForm10BEData(data.data);
        if (data?.data?.content.length === 0) {
          handleErrorToast();
        }
      } else {
        console.error('Failed to fetch contribution data');
      }
    } catch (error) {
      console.log(error);
      setIsLoading(false);
    } finally {
      setIsLoading(false);
    }
  };

  const openForm10BE = (s3Url) => {
    if (s3Url) {
      window.open(s3Url, '_blank');
    } else {
      toast.error('Something Went Wrong Please Contact Support', {
        position: 'top-center',
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        draggable: true,
        closeButton: false,
      });
    }
  };
  useEffect(() => {
    if (form10BEData.content) {
      const updatedTableData = form10BEData?.content?.map((item, index) => {
        const serialNumber = currentPage * pageSize + index + 1;
        return {
          id: item?.id,
          column1: serialNumber,
          column2: item?.contributionYear,
          column3: item?.fileName,
          column4: (
            <Button onClick={() => openForm10BE(item?.s3Url)}>
              <DownloadIcon />
              Form10 BE
            </Button>
          ),
        };
      });
      setTableData(updatedTableData);
    }
  }, [form10BEData.content]);
  const tableHeaders = ['S.No.', 'Year', 'File Name', 'Action'];
  const handleDateChange = (date) => {
    setSelectedDateForApi(date.$y);
    fetchForm10BEDataWhileOnchange(date.$y);
  };
  const TITLE = 'Form 10BE - BSG Contribution Site';
  return (
    <div>
      <Helmet>
        <title>{TITLE}</title>
      </Helmet>
      <UserBoxx>
        <UserInfo />
        <ContRicipt>
          <Heading margin="20px">Download Form10BE</Heading>
          <CenteredContainer>
            <Text
              fontWeight="500"
              size="16px"
              color="#484848"
              style={{ width: '100%', textAlign: 'left' }}
            >
              Thank You very much for your sincere and precious contribution for
              kosen-rufu
            </Text>
          </CenteredContainer>
          <CenteredContainer style={{ marginTop: '0' }}>
            <Text
              fontWeight="500"
              Size="16px"
              color="#484848"
              style={{ width: '100%', textAlign: 'left' }}
            >
              Following is the list of Form 10 BE against your contributions(s)
              to Bharat Soka Gakkai in the last financial year. In case of any
              query, please write to us at{' '}
              <a href="mailto:contribution@bharatsokagakkai.org">
                contribution@bharatsokagakkai.org
              </a>
            </Text>
          </CenteredContainer>
          <div
            style={{
              display: 'flex',
              marginBottom: '24px',
            }}
          >
            <div style={{ width: '70%' }} />
            <div style={{ width: '30%' }}>
              <AutoCompleteDropdown
                options={financialFields.map((field) => ({
                  value: field.value,
                  label: field.label,
                }))}
                label="Select FY"
                value={selectedFinancialField}
                onChange={(selectedValue) => {
                  setSelectedFinancialField(selectedValue?.value);
                  setSelectedDateForApi(selectedValue?.value);
                  fetchForm10BEDataWhileOnchange(selectedValue?.value);
                }}
                inputProps={{ required: false }}
                useHiddenInput
                disableClearable
              />
            </div>
          </div>
          {tableData?.length ? (
            <Box>
              <DataTable
                data={tableData}
                contributionData={form10BEData}
                headers={tableHeaders}
                onPageChange={handlePageChange}
              />
            </Box>
          ) : (
            !tableData?.length && isLoading === false && <NoData />
          )}
          {isLoading && <Loader />}
        </ContRicipt>
      </UserBoxx>
    </div>
  );
};

export default ContributionForm10BEListing;
